interface IDelayedAction {
  execute: (...params) => void | Promise<any>;
}

export class DelayedActionsService {
  private delayedActions: { [key: string]: IDelayedAction } = {};

  addDelayedAction = (key: string, doAction: (...params) => void): void => {
    if (this.delayedActions[key]) {
      delete this.delayedActions[key];
    }

    this.delayedActions[key] = { execute: doAction };
    document.dispatchEvent(new CustomEvent(key));
  };

  execute = <T extends Array<any>>(key: string, params: T): Promise<any> => {
    if (this.delayedActions[key]) {
      const result = this.delayedActions[key].execute(...params);
      delete this.delayedActions[key];

      if (result instanceof Promise) {
        return result;
      } else {
        return Promise.resolve(result);
      }
    }

    return Promise.resolve();
  };

  cancelDelayedAction = (key: string): void => {
    if (this.delayedActions[key]) {
      delete this.delayedActions[key];
    }
  };

  isExitDelayedAction = (key: string): boolean => {
    return Boolean(this.delayedActions[key]);
  };
}
